import styled from 'styled-components';
import { SearchResultCardStyles } from '../SearchResultCard.styles';
const Container = styled.div ``;
const TopBar = styled.div `
  display: flex;
  justify-content: space-between;

  img {
    max-height: 100px;
  }
`;
const Logo = styled.div ``;
const Date = styled(SearchResultCardStyles.Date) `
  margin-left: unset;
  margin: 0;
`;
export const EventResultCardStyles = {
    Container,
    TopBar,
    Logo,
    Date,
};
